import { Component, OnDestroy, OnInit, Input, ViewChild, NgZone ,ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription, concatMap, interval, of, map, Observable, catchError } from 'rxjs';
import { LoggingMessageService } from 'src/app/core/services/logging-message.service';
import { PendoService } from 'src/app/core/services/pendo.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';
import { SiteManagementService } from '../../services/site-management.service';
import { DataResult } from '../../models/data-result.model';
import { MenuAccessComponent } from '../site-coordinator/menu-access/menu-access.component';
import { DataEntryAccessComponent } from '../site-coordinator/data-entry-access/data-entry-access.component';
import { FormBuilder, FormGroup, FormControl,Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { UserDetailResult } from '../site-coordinator/models/user-result.model';
import { UserDetails, MainMenuAccess, DataEntryAccess } from '../site-coordinator/models/user-details.model';
import { GridDetails } from '../site-coordinator/models/grid-details.model';
import { Location } from '@angular/common';
import { LinkUtils } from 'src/app/shared/link-utils';
import { AuthService } from '../../services/auth.service';
import { FederationService } from "../../services/federation.service";

@Component({
  selector: 'app-site-coordinator',
  templateUrl: './site-coordinator.component.html',
  styleUrls: ['./site-coordinator.component.css']
})

export class SiteCoordinatorComponent implements OnInit, OnDestroy {
  public hospid: number;
  private loading = false;
  private $subscriptions: Subscription = new Subscription();
  private $navigationSubscription: Subscription;
  public userData = [];
  public userRoleData = [];
  public editUserForm: FormGroup;
  private linkid: string;
  selectedUser = 0;
  selectedUserRole = 0;
  isActive: boolean;
  originalSelectedUser: number;
  originalSelectedUserRole: number;
  originalIsActive: boolean;
  isPowerUser: boolean = false;
  mainMenuForceCheckedIndicators: [];  
  mainMenuForceUncheckedIndicators: [];
  @Input() facilityUserID: number;
  @ViewChild(DataEntryAccessComponent) dataEntryAccessComponent: DataEntryAccessComponent;  //so that the all the child function is viewable in parent.
  @ViewChild(MenuAccessComponent) menuAccessComponent: MenuAccessComponent;  //so that the all the child function is viewable in parent.
  public showTab: boolean = true;
  loggedinUserId: string;
  loggedinUserRole: number;  
  public userdetails: UserDetails;
  public mainMenuAccess: MainMenuAccess;
  public dataEntryAccess: DataEntryAccess;
  public griddetails: GridDetails;
  public userDetailResult: UserDetailResult;
  successMessage: string;
  public isRoleDisabled: boolean;
  public isActiveChkbxDisabled: boolean;
  public isActivateHidden: boolean;
  public lastLoginDate: string;
  
  message: {
    text: string;
    class: string;
  } = {
    text: '',
    class: ''
  };
  public isRoleChanged = false;
  public isActiveChanged = false;
  
  public isDataLoading() {
    return this.loading;
  } 

  constructor(private router: Router,
    private route: ActivatedRoute,
    private pendoService: PendoService,
    private logger: LoggingMessageService,
    private storageService: StorageService,
    private authService: AuthService,
    private dataService: SiteManagementService,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private location: Location,
    private federationService: FederationService) { 

      this.editUserForm =  this.formBuilder.group({
        // Define your form controls here
        userSelection: ['', Validators.required],
      });

      this.$navigationSubscription = this.router.events
      .subscribe((e: any) => {
        // If it is a NavigationEnd event display the page
        if (e instanceof NavigationEnd) {
          this.handleNavigationEvent();
        }
      },
      );
    }



  ngOnInit(): void {
    this.isRoleDisabled = true;
    this.isActivateHidden = true;
    this.lastLoginDate = '';

    this.subscribeToUserData(this.hospid);
    this.subscribeToUserRoleData(this.hospid);    
    this.loggedinUserId = this.storageService.getUserHospId();  
  }

  private handleNavigationEvent() {
    this.hospid = 0;
    this.updateHospitalId();
    this.updateLinkId();
    // this.updateSelectedSubscription();

    if (environment.EnablePendo) {
      this.pendoService.updatePendo(window, this.authService.SelectedSubscription.toString(), this.authService.AvailableSubscriptionsString);
    }

     this.logger.debug('app-site-coordinator', 'User Management - handleNavigation', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `Hospid:${this.hospid}`, '');
  }

  private subscribeToUserData(hospid: number) {
    this.logger.info('site-coordinator.component', 'subscribeToUserData', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,`Getting User Data`, '');
    
    this.loading = true;
    // this._displayWebErrors = true;
    const userData$ = this.dataService.getUserList(hospid)
      .subscribe(ud => {
        const userResult = ud as DataResult;
        if (userResult.Ok === true) {
          // Update the userData array with the new data
          this.userData = userResult.Data;
          this.logger.info('site-coordinator.component', 'subscribeToUserData', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,`User Data in process`, '');
    
          // Initialize the "activeStatus" property for each user. "activeStatus" will be used so that the status remains after saved when user-dropdown is changed.
          this.userData.forEach((user) => {
            user.activeStatus = user.activeYN;
          // user.roleID = user.roleID;
          });
        } else {
          this.logger.warn('app-site-coordinator', 'subscribeToUserData', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,`Result:${userResult.Status}, Status:${userResult.StatusText}`, '');
        }
        this.loading = false;
      },
      error => {
         this.logger.error('app-site-coordinator', 'subscribeToUserData', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,'caught error', error);
        this.loading = false;
      });
    this.$subscriptions.add(userData$);

    // Manually trigger change detection: Adding below code b/c upon certain user save, other useres Role would change and the dropdown would not reflect the change.
    // Adding change detection after updating the userData array to ensure that the UI updates immediately.
    this.cdr.detectChanges();
    //  // Run change detection in the Angular zone to update the UI
    this.ngZone.run(() => {});
    this.postWindowMessage();
  }

  private subscribeToUserRoleData(hospid: number) {
    this.logger.info('site-coordinator.component', 'subscribeToUserRoleData', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,`Getting Role Data`, '');
    
    this.loading = true;
    // this._displayWebErrors = true;
    const userRoleData$ = this.dataService.getUserRoleList(hospid)
      .subscribe(ud => {
        const userRoleResult = ud as DataResult;
        if (userRoleResult.Ok === true) {
          this.userRoleData = userRoleResult.Data;
          this.logger.info('site-coordinator.component', 'subscribeToUserRoleData', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,`Role Data in process`, '');
    
        } else {
          this.logger.warn('app-site-coordinator', 'subscribeToUserRoleData', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,`Result:${userRoleResult.Status}, Status:${userRoleResult.StatusText}`, '');
        }
        this.loading = false;
      },
      error => {
         this.logger.error('app-site-coordinator', 'subscribeToUserRoleData', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,'caught error', error);
        this.loading = false;
      });
    this.$subscriptions.add(userRoleData$);
  }

  private updateHospitalId() {
    const hospid = this.route.snapshot.queryParams.hospid;
    if (hospid) {
      this.hospid = Number(hospid);
    }
  }

  private updateLinkId() {
    const linkid = this.route.snapshot.queryParams.linkid;
    if (linkid) {
      this.linkid = linkid;
    }
  }

  // private updateSelectedSubscription() {
  //   const subscriptionId = LinkUtils.GetSubscription(this.linkid);
  //   this.authService.SelectedSubscription = subscriptionId;
  // }
  
  clearAPIMessage() {
    this.message = null;
    this.successMessage = null;
  }

  onSave(hospid: number) {
    this.clearAPIMessage();  
    this.onSaveUser(hospid);  
    this.postWindowMessage();
  }

  onSaveUser(hospid: number) {
     this.logger.debug('site-coordinator.component', 'onSaveUserAccess', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,`Saving user access`, '');
    
    //getting the parameter that needs to be passed to buss API based on userData (facilityUserID, hospid, roleID, BackupSC, active)   
   const selectedUserData = this.userData.find(user => user.facilityUserID === this.selectedUser);
  
   //getting menuData/DataEntry parameter 
   const updatedMenuAccessData = this.menuAccessComponent.menuData;
   const updatedDataAccessData = this.dataEntryAccessComponent.dataEntry;  
   
  const mainMenuAccess: MainMenuAccess = {
    permissions: updatedMenuAccessData
  };

  const dataEntryAccess: DataEntryAccess = {
    permissions: updatedDataAccessData
  };

  //getting role value: this most likey not needed, as we are passing roleID in the API call - this is just sanity check
  switch (this.selectedUserRole) {
    case 1:
      selectedUserData.role = 'Site Coordinator'
      break;
  
    case 2:
      selectedUserData.role = 'Backup Coordinator'
      break;
  
    case 3:
      selectedUserData.role = 'User'
      break;
  
    case 5:
      selectedUserData.role = 'Survey Coordinator'
      break;

    case 6:
      selectedUserData.role = 'Retired Coordinator'
      break;
      
    case 7:
      selectedUserData.role = 'NDNQI Admin'
      break;
  
    // Default case for handling other values
    default:
      selectedUserData.role;
  }

  const userdetails = new UserDetails(
    this.selectedUser,
    hospid,
    0,
    selectedUserData ? selectedUserData.userLastName: '', 
    selectedUserData ? selectedUserData.userFirstName: '',
    selectedUserData ? selectedUserData.userEmail: '',
    this.isActive,
    this.selectedUserRole, 
    selectedUserData ? selectedUserData.role : '', 
    selectedUserData ? selectedUserData.backupSC : undefined, 
    selectedUserData ? selectedUserData.allowEditPermissions : undefined,
    selectedUserData ? selectedUserData.allowEditRole : undefined, 
    selectedUserData ? selectedUserData.lastLoginDate : '' ,
    mainMenuAccess,
    dataEntryAccess,
    selectedUserData ? selectedUserData.activeStatus: false, 
  );

  // Store the original selected user value so that we get back this original value upon cancel click.
  this.originalSelectedUser = this.selectedUser;
  this.originalSelectedUserRole = this.selectedUserRole;

   // Store the selectedUser value in a separate variable so that after save, it stays in  seleted value in dropdown.
  const savedSelectedUser = this.selectedUser;

  const userDetailResult = new UserDetailResult(false, 400, '', userdetails);
  const details = JSON.stringify(userdetails);
   this.logger.debug('user-detail.component', 'onSaveUser', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, details, '');

    // Create the save observable chain
    this.logger.info('site-coordinator.component', 'saveUser', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Step 1a Starting: Saving user data', `User: ${selectedUserData.userEmail}`);
    const saveOperation$ = this.dataService.saveUser(userDetailResult).pipe(
      concatMap(response => { // Step 1: Save
        if (response.statusCode == 200 && response.userdetails[0].status === 1) {
          this.logger.info('site-coordinator.component', 'saveUser', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Step 1b Complete: Initial save successful', `Status: ${response.statusCode}`);
          // Save successful, proceed to data refresh
          this.selectedUser = savedSelectedUser;
          const successMsg = response.userdetails[0].msg == "" ? 'Saved Successfully' : response.userdetails[0].msg;
          this.message = this.dataService.getAPIMessage(successMsg, 'success-message');
          
          // Return an observable that completes when the user data is refreshed
          this.logger.info('site-coordinator.component', 'saveUser', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Starting: GetUserList', `User: ${selectedUserData.userEmail}`);
          return this.dataService.getUserList(this.hospid).pipe(  // Step 2: Data refresh
            map(ud => {
              const userResult = ud as DataResult;
              if (userResult.Ok === true) {
                this.userData = userResult.Data;
                
                const userID = this.selectedUser;
                const selectedUserAfterSuccessfulSave = this.userData.find(user => user.facilityUserID === userID);
                if (selectedUserAfterSuccessfulSave) {
                  this.selectedUser = selectedUserAfterSuccessfulSave.facilityUserID;
                }

                // Log successful save and data refresh completion
                this.logger.info('site-coordinator.component', 'saveUser', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Step 2 Complete: Save and data refresh completed successfully', `User: ${selectedUserAfterSuccessfulSave.userEmail}, Response: ${JSON.stringify(response.userdetails[0])}`);
                
                 // Return both the response and updated user data to the next operator (so it can be used in federation call)
                return { response, updatedUser: selectedUserAfterSuccessfulSave };
              } else {
                throw new Error('Failed to refresh user data');
              }
            })
          );
        } else {
          const errorMessage = response.userdetails[0].msg;
          this.message = this.dataService.getAPIMessage(errorMessage, 'error-message');
          throw new Error(errorMessage);
        }
      }),
      concatMap(response => { // Step 3: Federation (if needed)
        // Only proceed with federation after successful save and data refresh
        if (!environment.isFederal && selectedUserData.activeYN != response.updatedUser.activeYN) {
          this.logger.info('user-management.component', 'saveUser', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Step 3a: Save and refresh completed, proceeding with handling federation', `UserEmail: ${selectedUserData.userEmail}`);
          return this.handleFederation(response.updatedUser).pipe(  // Starts federation process
            map(() => response.updatedUser)
          );
        }
        return of(response.updatedUser);
      }),
      map(updatedUser => { // Update UI
        this.cdr.detectChanges();
        this.ngZone.run(() => {});
        this.postWindowMessage();
        return updatedUser;
      }),
      catchError(error => {
        this.logger.error('user-management.component', 'saveUser', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Save process failed', `Error: ${JSON.stringify(error)}`);
        this.message = this.dataService.getAPIMessage('An API error occurred', 'error-message');
        this.cdr.detectChanges();
        throw error;
      })
    );

    // Add to subscriptions for cleanup
    this.$subscriptions.add(saveOperation$.subscribe());
  }

  private handleFederation(selectedUserData: any): Observable<DataResult> {
    this.logger.info('site-coordinator.component', 'handleFederation', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Step 3b Starting: Getting federation token', `User: ${selectedUserData.userEmail}`);
    
    return this.federationService.getFederationToken().pipe(    // Step 3a: Get federation token
      concatMap(data => {
        if (!data) {
          //LOCAL DO NOT CHECK IN
          if (environment.environment == 'Local') {
            this.logger.info('site-coordinator.component', 'handleFederation', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'No federation token received', 'Proceeding with federation call');
            return this.federationService.FederationCall(selectedUserData);
          }
          else{          
            this.logger.error('site-coordinator.component', 'handleFederation', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Step 3a Complete: No federation token received', 'Federation process cannot proceed');
            return of(new DataResult(false, 500, 'Federation Failed', 'No federation token received'));
          }
        }

        const result: DataResult = data;
        if (result.Ok === true && result.Data) {
          this.authService.setFederationToken(result.Data);
          this.logger.info('site-coordinator.component', 'handleFederation', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Step 3c Complete: Federation token received and set', `Token status: ${result.Ok}`);

          this.logger.info('site-coordinator.component', 'handleFederation', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Step 4a Starting: Making federation call', `User: ${selectedUserData.userEmail}`);          
          return this.federationService.FederationCall(selectedUserData).pipe(
            map(fedResult => {
              this.logger.info('site-coordinator.component', 'handleFederation', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Step 4b Complete: Federation call finished', `Status: ${fedResult.Status}`);
              return fedResult;
            })
          );
        }

        this.logger.error('site-coordinator.component', 'handleFederation', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Failed to get valid federation token', `Status: ${result.Status}`);
        return of(new DataResult(false, result.Status || 500, 'Service Unavailable error', null));
      })
    );
  }

// In the parent component class
onMainMenuSaveSuccess(message: string) {
  this.successMessage = message;
  this.showMessage();
  this.postWindowMessage();
}

onDataEntrySaveSuccess(message: string) {
  this.successMessage = message;
  this.showMessage();
  this.postWindowMessage();
}


showMessage() {
  if (this.successMessage) {
    this.message = {
      text: this.successMessage,
      class: 'success-message'
    };
  }
}

  onCancelUser(){

     //clear API message
     this.clearAPIMessage();

    // Reset the checkbox value to the original value if it was changed.
    if (this.isActiveChanged)
    {
      this.isActive = this.originalIsActive;
    }

    // assuming user has changed
    if (typeof this.originalSelectedUser !== 'undefined')  
    {  
      this.menuAccessComponent.refreshMenuData(this.originalSelectedUser);
      this.dataEntryAccessComponent.refreshDataEntry(this.originalSelectedUser);
      this.selectedUserRole = this.originalSelectedUserRole;

     const selectedRole = this.userRoleData.find(role => role.roleID === this.selectedUserRole);
     //refresh the checkboxes on Main/DataEntry based on original role: mainMenuForceCheckedIndicators and mainMenuForceUncheckedIndicators
     this.mainMenuForceCheckedIndicators = selectedRole.mainMenuForceCheckedIndicators;
     this.mainMenuForceUncheckedIndicators = selectedRole.mainMenuForceUncheckedIndicators;
    }
    //most likely never happens but for sanity check - this is for initial user only: originalUser will be undefined when user has not changed the initial user yet.
    else 
    {
      this.menuAccessComponent.refreshMenuData(this.originalSelectedUser);
      this.dataEntryAccessComponent.refreshDataEntry(this.originalSelectedUser);
      this.selectedUserRole = this.originalSelectedUserRole;
    }

    this.postWindowMessage();

    // // Assuming user has changed
    // if (typeof this.originalSelectedUser !== 'undefined') {
    //   this.dataService.getMainMenuAccess(this.originalSelectedUser).subscribe(() => {
    //     // Additional logic after API call, if needed
    //     this.selectedUserRole = this.originalSelectedUserRole;
    //   });
    // } else {
    //   this.dataService.getMainMenuAccess(this.selectedUser).subscribe(() => {
    //     // Additional logic after API call, if needed
    //     this.selectedUserRole = this.originalSelectedUserRole;
    //   });
    // }
  }

  isCancelHidden(selectedUser: number): boolean{
    return !selectedUser;
  }
  
  confirmDelete(hospid: number) {
    const user = this.userData.find(user => user.facilityUserID  === this.selectedUser); 
    const fullName = user.userFirstName + ' ' + user.userLastName
    this.clearAPIMessage();
    this.confirmationService.confirm({
      key: 'deleteUserConfirmation',
      message: `You are about to delete user - "${fullName}".<p></p>Are you sure that you want to proceed ?`,
      header: 'Confirm Delete',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Reject',
      accept: () => {
        this.onDeleteUser(hospid);
      },
      reject: () => {
        this.messageService.add({ key: 'user', severity: 'info', summary: 'Cancelled', detail: 'You have cancelled the delete action' });
      }
    });
  }


  onDeleteUser(hospid: number){
     this.logger.debug('site-coordinator.component', 'onDeleteUserAccess', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `Deleting user access`, '');
    //todo Delete User Access
    this.$subscriptions.add(
      this.dataService.deleteUser(this.selectedUser)
        .subscribe(response => {
          if (response[0].status === 1) {
            // Save was successful
            //todo: get the new userlist.
            this.selectedUser = null;
            this.selectedUserRole = null;
            this.subscribeToUserData(hospid); 
            this.selectedUser = null;
            this.selectedUserRole = null;
            // Display success message to the user: if succ. should be GREEN (BIND CLASS TO msg. it's the class that displays green or red)
            //this.dataService.showAPIMessage('User deleted successful', 'success-message');
            this.message = this.dataService.getAPIMessage('User deleted successful', 'success-message');
          } else {
            // Save was not successful
            // Display error message from the API response to the user
            const errorMessage = response[0].msg;
            //this.dataService.showAPIMessage(errorMessage,'error-message');
            this.message = this.dataService.getAPIMessage(errorMessage, 'error-message');
          }
          setTimeout(() => {
          });
        },
        error => {
          // Handle API call error
          //this.dataService.showAPIMessage('An error occurred on delete user - API call error' , 'error-message');
          this.message = this.dataService.getAPIMessage('An error occurred on delete user - API call error', 'success-message');
        })
    );
    this.postWindowMessage();
  }

  //If you select a Site Coordinator, Backup SC or Admin, the delete button is hidden
  isDeleteHidden(selectedUserRole: number): boolean{
    return selectedUserRole !== 3;
  }

  onUserSelectionChange(changeValue: any): void {

    this.clearAPIMessage();    
    this.isActivateHidden = this.isActivateChkBxHidden(changeValue);
    this.isRoleDisabled = true;
    this.lastLoginDate = '';

   //get a updated userlist
   this.subscribeToUserData(this.hospid);

   this.cdr.detectChanges(); // Trigger change detection

    const selectedUserId = Number(changeValue);
    const selectedUser = this.userData.find(user => user.facilityUserID === selectedUserId);
    
    if (selectedUser) {
      this.selectedUser = selectedUser.facilityUserID;
      this.cdr.detectChanges();
      // Run change detection in the Angular zone to update the UI
     this.ngZone.run(() => {});
      this.postWindowMessage();

      // Update the selectedUserRole based on the selected user's role
      this.selectedUserRole = selectedUser.roleID;  

      //the originalselectedUser/Role is used to reset upon cancel click
      this.originalSelectedUser = this.selectedUser;   
      this.originalSelectedUserRole = this.selectedUserRole;

      this.isDeleteHidden(this.selectedUserRole);
      this.isRoleDisabled = this.isUserRoleDisabled();
      this.isActiveChkbxDisabled = this.isUserActiveChkbxDisabled();
      this.lastLoginDate = this.getFormattedLastLoginDate();

      //upon user change what is the isPowerUser? This will be used for on/off in dataEntry Permission chkbx
      const selectedRole = this.userRoleData.find(role => role.roleID === this.selectedUserRole);
      this.isPowerUser = selectedRole?.isPowerUser == true;
      // Update the "isActive" checkbox value based on the "activeStatus" property. - "activeStatus" is used to keep the activity status after saved, when user-dropdown is changed.
      this.isActive = selectedUser.activeStatus;      
      this.mainMenuForceCheckedIndicators = selectedRole.mainMenuForceCheckedIndicators;
      this.mainMenuForceUncheckedIndicators = selectedRole.mainMenuForceUncheckedIndicators;

      
    } else {
      this.selectedUser = null;
      this.selectedUserRole = null;
    }
    this.postWindowMessage();
  }
  //Dropdown options being recreated on each user selection change, causing the selected value to be lost (When changing user and trying to get fresh userList).
  //Use trackBy in the *ngFor to track options by ID:
  trackById(index, user) {
    return user.facilityUserID;
  }
  onUserRoleSelectionChange($changeValue) {
    
     this.clearAPIMessage();

     this.isRoleChanged = true;
     const newSelectedUserRole = Number($changeValue); // Get the newly selected role ID
     
    //upon role change what is the isPowerUser? or other values: This will be used for on/off in dataEntry Permission chkbx
    const selectedRole = this.userRoleData.find((role) => role.roleID === newSelectedUserRole);

    this.isPowerUser = selectedRole?.isPowerUser == true;
    this.mainMenuForceCheckedIndicators = selectedRole.mainMenuForceCheckedIndicators;
    this.mainMenuForceUncheckedIndicators = selectedRole.mainMenuForceUncheckedIndicators;

    //find out loggedinUserRole: calculation is done in Init() which returns a string.    
    const userDataBasedonLoggedUserID = this.userData.find(user => user.facilityUserID  === parseInt(this.loggedinUserId));
    this.loggedinUserRole = userDataBasedonLoggedUserID?.roleID;
   
    //Upon role change if loggedinUser = BSC and selectedRole=SC,  let the role ddl to be what it was and Show error msg : "You Are a Back-up Site Coordinator. A Backup Site Coordinator cannot edit a Site Coordinator's role."
    if (newSelectedUserRole == 2 && this.loggedinUserRole == 2)
    { 
      this.message = this.dataService.getAPIMessage('You are a Backup Site Coordinator. A Backup Site Coordinator cannot set another user as a Backup Site Coordinator.', 'error-message');
      this.cdr.detectChanges(); // Trigger change detection
    }
    //if loggedin user is SC=1, you can't make other user to be SC
    else if(this.loggedinUserRole == 1 && newSelectedUserRole == 1)
    {
      this.message = this.dataService.getAPIMessage('You are a Site Coordinator. A Site Coordinator cannot set another user as a Site Coordinator.', 'error-message');
    }   
    else {
      // Update the selectedUserRole with the new value
      this.selectedUserRole = newSelectedUserRole;

       // Update the role of the selected user in the userData array
      const selectedUser = this.userData.find((user) => user.facilityUserID === this.selectedUser);
      if (selectedUser) {
        selectedUser.roleID = newSelectedUserRole;
      }
    }

    //  // Run change detection in the Angular zone to update the UI
     this.ngZone.run(() => {});
     this.postWindowMessage();
  }

  onActiveChange(): void {
    this.clearAPIMessage();

    //find out loggedinUserRole:
    const userDataBasedonLoggedUserID = this.userData.find(user => user.facilityUserID  === parseInt(this.loggedinUserId));
    const loggedinUserRole = userDataBasedonLoggedUserID?.roleID; 

    // Store the original value of the checkbox : will be used to reset upon cancel click    
    this.originalIsActive = !this.isActive;
    this.isActiveChanged = true;

    // Find the selected user.
    const selectedUser = this.userData.find(
      (user) => user.facilityUserID === this.selectedUser
    );

    
    //Upon Activity change to true If logedInUserRole=SC=1 && selectedUser.Role=SC=1 && selectedUser.activeStatus === true show error msg.
    if (loggedinUserRole == 1 && selectedUser.roleID == 1 && this.isActiveChanged == true && this.originalIsActive == false)
    {
      this.message = this.dataService.getAPIMessage("You are already a Site Coordinator and cannot activate another user to be a Site Coordinator", 'error-message');
    }

    //Upon Activity change to true: if loggedinUser = BSC and selectedRole=BSC show error msg
    if (loggedinUserRole == 2 && selectedUser.roleID == 2 && this.isActiveChanged == true && this.originalIsActive == false)
    { 
      this.message = this.dataService.getAPIMessage('You are a Backup Site Coordinator. A Backup Site Coordinator cannot set another user as a Backup Site Coordinator.', 'error-message');
    }

    // Update the "activeStatus" property based on the "isActive" checkbox value.
    if (selectedUser) {
      selectedUser.activeStatus = this.isActive;
    }
    this.postWindowMessage();
  }
  

  isActivateChkBxHidden(selectedUser){
    if (selectedUser === 0 || selectedUser === '0'|| selectedUser === null)
      return true;
    else
      return false;
  }
  
  //Hide save btn if no user is seleced
  get isSaveHidden(): boolean { 
    
    // //find out loggedinUserRole: calculation is done in Init() which returns a string.    
    // const userDataBasedonLoggedUserID = this.userData.find(user => user.authUserID  === parseInt(this.loggedinUserId));
    // this.loggedinUserRole = userDataBasedonLoggedUserID?.roleID;

    if (this.selectedUser === 0 || this.selectedUser === null) //|| ((this.selectedUserRole == 1 || this.selectedUserRole == 2 ) && this.loggedinUserRole == 2)) 
    {
      return true;
    }
    else    
      return false;
  }


  isLastLoginDateHidden(){
    const user = this.userData.find(user => user.facilityUserID  === this.selectedUser);  
    let date = user ? user.lastLoginDate : undefined; 
    if (this.selectedUser == 0 || date == null || date == "")
      return true;
    else
     return false;
   }

   isUserRoleDisabled(): boolean{  
    const user = this.userData.find(user => user.facilityUserID  === this.selectedUser);  //user.authUserID.toString() == 35225
    //this.storageService.getUserHospId();  this.loggedinUserId   //453951 

    //find out loggedinUserRole:
    const userDataBasedonLoggedUserID = this.userData.find(user => user.facilityUserID  === parseInt(this.loggedinUserId));
    let loggedinUserRole = userDataBasedonLoggedUserID?.roleID; 
    
    //Disabled "Role" drop-down if: no user selected OR 
    //selected user is Site Coordinator and logged user is Backup SC OR 
    //non-BSC user selects herself.
    if (typeof user !== 'undefined') 
    {
      if (typeof user.facilityUserID === 'undefined')
      {
        this.logger.info('site-coordinator.component', 'isRoleDisabled', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'user.facilityUserID is undefined.', '');
      }
      return (this.selectedUser === 0 || this.selectedUser === null || (this.loggedinUserId === user.facilityUserID.toString() && loggedinUserRole != 2))    //user selects herself (non-BSC)
            //(this.selectedUserRole == 1 && loggedinUserRole == 2) : selected user is Site Coordinator and logged user is Backup SC 
    }    
    else if (typeof user === 'undefined')
      return true;
    else
      return (this.selectedUser === 0)
   }

   isUserActiveChkbxDisabled(): boolean{
  
    const user = this.userData.find(user => user.facilityUserID  === this.selectedUser);
  
    //find out loggedinUserRole:
    const userDataBasedonLoggedUserID = this.userData.find(user => user.facilityUserID  === parseInt(this.loggedinUserId));
    const loggedinUserRole = userDataBasedonLoggedUserID?.roleID; 

  //disable when: Selected user is SC=1 and logged user is BackupSC=2  OR 
  //non-BSC user selects herself 
    if (typeof user !== 'undefined')    
      return (this.selectedUser === 0 || this.selectedUser === null  || (parseInt(this.loggedinUserId) == user.facilityUserID  && loggedinUserRole != 2))
              //( this.selectedUserRole == 1 && loggedinUserRole == 2) || 
    else
      return this.selectedUser === 0
   }

  getFormattedLastLoginDate(): string {
    if (this.selectedUser) {
      const user = this.userData.find(user => user.facilityUserID === this.selectedUser);
      if (user && user.lastLoginDate) {
        const date = new Date(user.lastLoginDate);
        return date.toLocaleDateString(); // Customize the date format        
      }
    }
    return '';
  }
   
  checkDataEntryTabStatus(status: boolean) {
    this.showTab = status;
  }

  private Unsubscribe() {
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
    if (this.$navigationSubscription) {
      this.$navigationSubscription.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.Unsubscribe();
  }

  private postWindowMessage() {
    setTimeout(() => {
      this.logger.info('site-coordinator.component', 'postWindowMessage', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `sysId=${this.hospid}`, '');
      window.parent.postMessage('indicatorfactoryaction:', '*');
    }, 0);
  }

}
